<div class="app">
<app-header [navbarBrandRouterLink]="['/admin', 'plantingSites']"
            [fixed]="true"
            [navbarBrandFull]="{src: 'assets/img/trofaco-logo@2x.png'}"
            [navbarBrandMinimized]="{src: 'assets/img/trofaco-logo@2x.png', width: 30, height: 30, alt: 'TREFACO'}"
            [sidebarToggler]="'none'"
            [asideMenuToggler]="'none'">
    <ul class="nav navbar-nav">
        <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" [routerLink]="['/admin/plantingSites']">Planting Sites</a>
        </li>
        <li *ngIf="currentUser?.permissions.canReadCustomers" class="nav-item" routerLinkActive="active">
            <a class="nav-link" [routerLink]="['/admin/customers']">Customers</a>
        </li>
        <li *ngIf="currentUser?.permissions.canManageUsers" class="nav-item" routerLinkActive="active">
            <a class="nav-link" [routerLink]="['/admin/users']">Users</a>
        </li>
        <li *ngIf="currentUser?.permissions.canManageUsers" class="nav-item" routerLinkActive="active"> <!-- Change permission -->
            <a class="nav-link" [routerLink]="['/admin/treeSpecies']">Tree Species</a>
        </li>
    </ul>
    <ul class="nav navbar-nav ml-auto">
        <li class="nav-item dropdown" dropdown="" placement="bottom right">
            <a aria-haspopup="true" class="nav-link" href="#" (click)="logout($event)" role="button" aria-expanded="false"><i
                class="icon-power icons d-block"></i> Logout</a><!---->
        </li>
    </ul>
</app-header>
<div class="app-body" style="overflow-x: auto;">
    <!-- Main content -->
    <main class="main">

        <alert *ngFor="let message of messages" class="technical-error"
               [type]="message.status"
               [dismissOnTimeout]="message.timing * 1000"
               (onClosed)="onMessageClosed(message)">{{ message.message }}</alert>
        <div class="container-fluid">
            <router-outlet></router-outlet>
        </div><!-- /.container-fluid -->
    </main>
</div>
    <div class="app-footer">
        <span>Copyright © TROFACO 2019, Application Version: {{version}}</span>
    </div>
</div>
